import clsx from 'clsx';
import {Trans} from '@common/i18n/trans';
import {FormattedNumber} from '@common/i18n/formatted-number';
import {useLandingPageStats} from './use-landing-page-stats';

interface Props {
  className?: string;
}
export function LaunchOfferBanner({className}: Props) {
  const {data} = useLandingPageStats();
  const launchOffer = data?.stats.launchOffer;

  if (!launchOffer?.active || launchOffer.remaining <= 0) {
    return null;
  }

  return (
    <div
      className={clsx(
        'rounded-full border border-primary bg-primary/5 px-16 py-6 text-sm font-medium text-primary text-center',
        className,
      )}
    >
      <Trans
        message=":remaining of :total launch copies left"
        values={{
          remaining: <FormattedNumber value={launchOffer.remaining} />,
          total: <FormattedNumber value={launchOffer.total} />,
        }}
      />
    </div>
  );
}
